export default __webpack_public_path__ + "static/media/logo.55e2f18a.svg";